export const LISTING_LIST_PAGE_PATH = '/listing/list'

export const LISTING_CREATE_PAGE_PATH = '/listing/create'

export const LISTING_EDIT_PAGE_PATH = '/listing/edit'
